import React from 'react';
import { useClient } from 'shared/apollo';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import {
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
} from '@mui/material';
import { Heading, RowH, ColH, LinkClear, CloseIcon, CancelButton } from './styles';
import { useFormik } from 'formik';
import { editAccounts } from './api';

const prepareData = obj => {
  if (Object.prototype.hasOwnProperty.call(obj, 'dbId')) {
    obj.id = obj.dbId;
    delete obj.dbId;
  }
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
      delete obj[key];
    }
  }
  return obj;
};

const AccountEditModal: React.FC = ({
  open,
  setOpen,
  account,
  handleClose,
}) => {
  const client = useClient();

  const { values, setFieldValue, handleSubmit } = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: account,
    onSubmit: async value => {
      const data = prepareData(value);
      if (!data.totalNumber) {
        data.totalNumber = 0;
      }
      console.log(data);
      await editAccounts(client, data);
      handleClose({ success: true });
    },
  });

  return (
    <TrueImpactModal
      open={open}
      hideHeader={true}
      hideFooter={true}
      onClose={() => setOpen(false)}
    >
      <Heading>
        <CloseIcon onClick={handleClose} />
        <RowH>
          <ColH>
            <Typography variant="h2">Account Edit</Typography>
          </ColH>
        </RowH>
        <RowH>
          <ColH>
            <span>Name: {account?.name || '-'}</span>
          </ColH>
          <ColH>
            <span>ID: {account?.dbId}</span>
          </ColH>
        </RowH>
      </Heading>

      <ColH
        style={{
          paddingLeft: '25%',
          paddingRight: '25%',
          paddingTop: '10px',
          paddingBottom: '10px',
        }}
      >
        <RowH>
          <ColH style={{ marginRight: '10px' }}>
            <p>Name:</p>
            <TextField
              placeholder="Name"
              fullWidth
              values={values.name}
              onChange={e => setFieldValue('name', e.target.value)}
              defaultValue={values.name}
            />
          </ColH>
          <ColH>
            <p>Ein:</p>
            <TextField
              placeholder="ein"
              fullWidth
              values={values.ein}
              onChange={e => setFieldValue('ein', e.target.value)}
              defaultValue={values.ein}
            />
          </ColH>
        </RowH>

        <RowH>
          <ColH style={{ marginRight: '10px' }}>
            <p>Website:</p>
            <TextField
              placeholder="website"
              fullWidth
              values={values.website}
              onChange={e => setFieldValue('website', e.target.value)}
              defaultValue={values.website}
            />
          </ColH>
          <ColH>
            <p>Mission Statement:</p>
            <TextField
              placeholder="missionStatement"
              fullWidth
              values={values.missionStatement}
              onChange={e => setFieldValue('missionStatement', e.target.value)}
              defaultValue={values.missionStatement}
            />
          </ColH>
        </RowH>

        <RowH>
          <ColH style={{ marginRight: '10px' }}>
            <p>Office Location:</p>
            <TextField
              placeholder="officeLocation"
              fullWidth
              values={values.officeLocation}
              onChange={e => setFieldValue('officeLocation', e.target.value)}
              defaultValue={values.officeLocation}
            />
          </ColH>
          <ColH>
            <p>Org Year:</p>
            <TextField
              placeholder="orgYear"
              fullWidth
              values={values.orgYear}
              onChange={e => setFieldValue('orgYear', e.target.value)}
              defaultValue={values.orgYear}
            />
          </ColH>
        </RowH>

        <RowH>
          <ColH>
            <p>Woman:</p>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.woman}
                  onChange={e => setFieldValue('woman', e.target.checked)}
                  color="primary"
                />
              }
              label="Yes"
            />
          </ColH>
          <ColH>
            <p>Number Of Women:</p>
            <TextField
              placeholder="numberOfWomen"
              fullWidth
              values={values.numberOfWomen}
              onChange={e => setFieldValue('numberOfWomen', e.target.value)}
              defaultValue={values.numberOfWomen}
            />
          </ColH>
        </RowH>

        <RowH>
          <ColH>
            <p>Person of color:</p>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values.personOfColor}
                  onChange={e =>
                    setFieldValue('personOfColor', e.target.checked)
                  }
                  color="primary"
                />
              }
              label="Yes"
            />
          </ColH>
          <ColH>
            <p>Number of people of color:</p>
            <TextField
              placeholder="numberOfpeopleOfColor"
              fullWidth
              values={values.numberOfpeopleOfColor}
              onChange={e =>
                setFieldValue('numberOfpeopleOfColor', e.target.value)
              }
              defaultValue={values.numberOfpeopleOfColor}
            />
          </ColH>
        </RowH>

        <RowH>
          <ColH>
            <p>Total number:</p>
            <TextField
              placeholder="totalNumber"
              fullWidth
              values={values.totalNumber}
              onChange={e => setFieldValue('totalNumber', e.target.value)}
              defaultValue={values.totalNumber}
            />
          </ColH>
        </RowH>

        <RowH>
          <ColH>
            <Button fullwidth onClick={handleSubmit}>
              Save
            </Button>
          </ColH>
          <ColH style={{paddingLeft: '3px'}}>
            <CancelButton onClick={handleClose}>Cancel</CancelButton>
          </ColH>
        </RowH>
      </ColH>
    </TrueImpactModal>
  );
};

export default AccountEditModal;
